// extracted by mini-css-extract-plugin
module.exports = {"characteristics":"Characteristics_characteristics__xsfyW","rms-items":"Characteristics_rms-items__2k90e"};